import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: 'CarForce Home',
      keepAlive: false
    }
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
    meta: {
      title: 'CarForce About',
      keepAlive: false
    }
  },
  {
    path: '/myusers',
    name: 'myusers',
    component: () => import(/* webpackChunkName: "myusers" */ '../views/MyUsers.vue'),
    meta: {
      title: 'CarForce Benutzer',
      keepAlive: false
    }
  },
  {
    path: '/mybookings',
    name: 'mybookings',
    component: () => import(/* webpackChunkName: "mybookings" */ '../views/MyBookings.vue'),
    meta: {
      title: 'CarForce Buchungen',
      keepAlive: false
    }
  },
  {
    path: '/myadresses',
    name: 'myadresses',
    component: () => import(/* webpackChunkName: "myadresses" */ '../views/MyAdresses.vue'),
    meta: {
      title: 'CarForce Adressen',
      keepAlive: false
    }
  },
  {
    path: '/myoverview',
    name: 'myoverview',
    component: () => import(/* webpackChunkName: "myoverview" */ '../views/MyOverview.vue')
    ,
    meta: {
      title: 'CarForce Kalender',
      keepAlive: false
    }
  },
  {
    path: '/mycompanies',
    name: 'mycompanies',
    component: () => import(/* webpackChunkName: "mycompanies" */ '../views/MyCompanies.vue'),
    meta: {
      title: 'CarForce Firmen',
      keepAlive: false
    }
  },
  {
    path: '/mycargroups',
    name: 'mycargroups',
    component: () => import(/* webpackChunkName: "mycargroups" */ '../views/MyCargroups.vue'),
    meta: {
      title: 'CarForce Fzg.-Gruppen',
      keepAlive: false
    }
  },
  {
    path: '/myprint',
    name: 'myprint',
    component: () => import(/* webpackChunkName: "myprint" */ '../views/MyPrint.vue')
  }
]

const router = createRouter({
  //history: createWebHistory(process.env.BASE_URL),
  history: createWebHashHistory(),
  routes
})

export default router
